export default "__VITE_ASSET__DNvO1F_E__"